import { KEY } from 'components/tool/Editor/KeyboardShortcutsWarningModal/KeyBindings';
import { KEY as ROOF_KEY } from 'components/tool/Editor/KeyboardShortcutsWarningModalRoof/KeyBindings';
import styled from 'styled-components';

const ButtonStyle = styled.button`
	background: var(--primary);
  appearance: none;
  border: 1px solid var(--primary);
	padding: 0.45rem .72rem;
  border-radius: 3px;
  color: var(--btnLabel);
  font-weight: 500;
  font-size: 0.922rem;
  cursor: pointer;
	position: relative; // Added for positioning the loader
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: 'Inter', sans-serif;
	gap:0.5rem;
	min-height: 36px;
  min-width: 36px;
	overflow: hidden;

	&.no-focus-outline:focus {
		outline: none;
	}

	&.svg{
		border: 0px;
		position: relative;
		background: var(--defaultBgColor);
		color: var(--textTitleColor);


		&.strip{
			border-right: 1px solid var(--borderLightColor);
			border-left: 1px solid var(--borderLightColor);
		}
	}

	&#edge-redo{
		background: var(--defaultBgColor);
		border: 0px;
		border-left: 1px solid var(--borderLightColor);
		border-right: 0px;
		color: var(--primary);
		padding: 0px 4px 0 9px;
		min-height: 33px;
		@media(max-width:860px){
		 	 height: 30px;
			 min-height: 30px;
    }
	}
	&#edge-undo{
			background: var(--defaultBgColor);
			border:none;
			border-right: 1px solid var(--borderLightColor);
			border-left: 0px;
			color: var(--primary);
			padding: 0px 10px;
			transform: scale(-1, 1);
			min-height: 33px;
			@media(max-width:860px){
		 	 height: 30px;
			 min-height: 30px;
			 padding-left:6px;
				svg{
					width: 20px;
					height: 20px;
				}
	}	
}

	&.run-ai-btn{
		border-radius: 40px;
		background: var(--secondary);
		border: 1px solid var(--secondary);
		color: var(--darkAccentColor);
		padding-inline: 1.375rem;
		padding-block: 0.750rem;
		font-weight:600;
		font-size: 1.125rem;
		display: flex;
		align-items:center;
		gap: 8px;
		color: #07174D;
		min-width: 156px;
		box-shadow:0 4px 6px rgba(0, 0, 0, 0.2),
                0 1px 3px rgba(0, 0, 0, 0.15);
		transition: all 0.2s ease-in-out;
		svg{
			transition: transform 0.3s ease-out;
			position: relative;
		}
		&:hover{
			box-shadow: 0 6px 10px rgba(0, 0, 0, 0.3),
                0 2px 5px rgba(0, 0, 0, 0.2);			
					svg{
						transform: translateX(3px);
					}

		}
	}

	&#settings{
			border: 1px solid var(--controlBorderColor);
			font-size: 0.938rem;
			height: 38px;
			min-width: 39px;
			border-radius: 100%;
			background: var(--defaultBgColor);
			color: var(--textTitleColor);
			padding: 7.5px 8px;
			@media(max-width:860px){
				padding: 6px 8px;
				height: 34px;
				min-width: 36px;
				svg{
					width:16px;
					height: 16px;
				}
			}
	}
	&.btn-3d{
			border-radius: 20px;
			gap: .313rem;
			padding: 0.5rem 0.72rem;
			min-height: 35px;
			font-size: 0.875rem;
			
			@media(min-width:981px){
			 min-width: 70px;
			}
			 @media (max-width: 860px){
			 	padding: 0.48rem 0.45rem;
				svg{
						position: relative;
						left: 1px;
				 }
			 }
			@media (max-width: 540px){
			 	padding: 0.48rem 0.35rem;
			 }

		&.in-strip{
			border: none !important;
			border-radius: 0px !important;
			padding: 0px 7px 0px 3px;
			cursor: pointer;
			background: rgb(255, 255, 255) !important;
			min-height: 27px;
			min-width: auto;
			font-weight: 600;
			font-size: 14px;
			
			svg{
				position: relative;
				left: 1px;
    		width: 22px;
    		height: 22px;
			}
			&:hover {
				border: none !important;
				box-shadow: none !important;
  		}
			&.active {
				background: rgb(255, 255, 255) !important;
				color: var(--primary) !important;
				svg path {
      		stroke: var(--primary) !important;
    		}
			}
		}
	}
	
	&.fullscreenviewVisible{
			border-radius: 100%;
			background: var(--defaultBgColor);
			border-color: var(--controlBorderColor);
			color: var(--textTitleColor);
			padding: 6px 5px 6.5px 5px;
			min-width: 38px;
			min-height: 38px;
			&:not(.active){
				background: var(--primary);
				border-color: var(--primary);
				color: #fff;
				position: absolute;
				z-index: 2;
				top: 12px;
				right: 10px;

				&:hover, &:focus{
				background: var(--primary) !important;
				opacity: 1 !important;
				}
			}
	}
	&.toggleSatelliteViewBtn{
			width: 38px;
			height: 38px;
			min-width: 38px;
			min-height: 38px;
			padding: 2px;
			border-radius: 50%;
			border: 1px solid var(--controlBorderColor);
			background: var(--defaultBgColor);
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all .25s ease;
			cursor: pointer;
			// border-color: rgb(199, 202, 207);
			// background: var(--primary);
			// top: 12px;
			// right: 58px;
			// position: absolute;
			// z-index: 2;

			// &.fullscreenview-satelite{
			// 	right: 10px;
			// }

			&:not(.active):hover {
				background: var(--hoverBgColor);
				opacity: 0.9;
				// box-shadow: 0 4px 12px rgba(0,0,0,.12);
			}
			&.active {
				background: color-mix(in srgb, var(--primary) 18%, var(--defaultBgColor));
    		border: 1px solid var(--primary);
    		color: var(--primary);
			}
				svg {
					transition: transform .2s ease;
				}

				&:hover svg {
					transform: scale(1.01);
				}
	}
	&#developer-mode-btn{
			min-width: 38px;
    	min-height: 38px;
			background: var(--defaultBgColor);
			color: #fff;
			border-color: var(--controlBorderColor);
			border-radius:20px;
			padding: 0.5rem 0.2rem;
			&.active{
				background: color-mix(in srgb, var(--primary) 18%, var(--defaultBgColor));
				border-color: var(--primary);
			}
			&:not(.active):hover{
				background: var(--hoverBgColor);
				opacity: 0.9;
			}
	}	
	&.cancel-btn{
		background:var(--disabledBgColor);
		border: 1px solid var(--borderColor);
		color: var(--textTitleColor);
		font-size: 0.875rem;
		padding: .525rem 0.425rem;
		height: 38px;
		min-width: 38px;
		border-radius: 20px;
		box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 4px;
		@media (max-width: 840px){
			// height: 38px;
			min-width: 38.5px;
    }
			&.strip-cancel{
				border: none;
				height:30px;
				min-height: auto;
				min-width: auto;
				padding: 0.125rem 0.325rem;
				background: transparent;
				box-shadow: none;
				svg {
					position: relative;
					top: 1.35px;
				}
				&:hover{
					#cancel-path
							stroke:rgb(245, 129, 129) !important;
					}
				}
				}
			}
		&.side-modal-close {
			border-radius: 2px; !important;
			height: 34px;
			line-height: 1.4;
			padding: 4px 8px;
			min-height: 34px;
			font-size: 14px;
  	}
		&.side-modal-close--primary {
			background: var(--primary);
			border-color: var(--primary);
			color: #fff;

			&:hover, &:focus {
				background: var(--primary) !important;
				opacity: 1 !important;
			}
		}
	}
	&.btn-done{
			border: 1px solid rgba(0, 60, 255, 0.5);
			font-size: 0.875rem;
			padding: 5px 8px 4px;
			height: 38px;
			min-width: 82px;
			border-radius: 20px;
			box-shadow: rgba(100,100,100,0.12) 0px 2.25911px 4px;

			&.azimuthInvalid{
				opacity: .5 !important;
			}

			label{
				line-height:1.5;
			}

			@media (max-width: 840px){
			// height: 38px;
			min-width: 74px;

				// svg{
				// 	width: 19px;
				// 	height:19px;
				// }
			}
	}	
	&.btn-tools{
		border: 0px;
		border-left: 0px;
		color: #28373E;
		font-size: 0.938rem;
		border-radius: 0px;
		padding: 0px 8px;
		// transition: all 2s ease;
		height: 38px;
		width: auto;
		min-width: 40px;
	
		// @media(max-width:860px){
			// height: 38px;
		// }
	}		
	&#move-panel{
		border-right: 1px solid var(--borderLightColor);
		min-width: 40px;
		position: relative;
		&:before {
				position: absolute;
				right: 2px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
		}
		@media(max-width:860px){
			// height: 38px;
			// svg{
			// 	width: 17.6px;
			// 	height: 20px;
			// }
		}
	}		
	&#delete-panel{
		border-right: 0px;
		padding-right: 10px;
		position: relative;
		&:before {
				position: absolute;
				right: 9px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
		}
		@media(max-width:860px){
		//  height: 38px;
			// svg{
			// 	width: 18.40px;
			// 	height: 20px;
			// }
		}
	}
	&#add-panel{
		border-right: 1px solid var(--borderLightColor);
		padding: 0.125rem 0.5rem 0.125rem 11px;
		position: relative;
		&:before {
				position: absolute;
				right: 2px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
		}
		@media(max-width:860px){
		//  height: 38px;
			// svg{
			// 	width: 19.1px;
			// 	height: 20px;
			// }
		}
	}
	&#add-obstruction-btn{
		background: var(--defaultBgColor);
		min-width: 43px;
		position: relative;
		padding-right: 16px;
		width: auto;
		@media (hover: hover) and (pointer: fine){
			&:before {
				content: "${KEY.EDIT_OBSTRUCTION}";
				position: absolute;
				right: 11px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
		}
		}
	}	
	&#edit-trees{
		background: var(--defaultBgColor);
		min-width: 40px;
		position: relative;
		padding-right: 16px;
		width: auto;
		@media (hover: hover) and (pointer: fine){
			&:before {
				content: "${KEY.ADJUST_SHADING}";
				position: absolute;
				right: 3px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
			}
		}
	}
	&#delete-obstruction-mode{
			// border-right: 1px solid var(--borderLightColor);
			padding: 0px 12px 0px 8px;
			width: 40px;
			position: relative;
			&.remove-shading-disabled {
				padding-right: 14px;
				min-width: 40px;
				width: auto;
				&:before{
					right: 11px;
				}
			}
		@media (hover: hover) and (pointer: fine) {
			&:before {
					content: "${KEY.EDIT_OBSTRUCTION}";
					position: absolute;
					right: 5px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}
			// transition: all 2s ease;
			// @media(max-width:860px){
			// height: 38px;
			// svg{
			// 	width: 20px;
			// 	height: 20px;
			// }
		// }
		&.show-edge-tool{
			padding-right: 8px;
		}
	}
	&#edit-obstruction-mode{
		border-right: 1px solid var(--borderLightColor);
		background: var(--defaultBgColor);
		min-width: 40px;
		position: relative;
		&.active-shading{
			// padding-right: 16px;

			// @media (hover: hover) and (pointer: fine){
			// 	&:before {
			// 		right: 11px;
			// 	}
			// }
		}
		width: auto;
		@media (hover: hover) and (pointer: fine){
			&:before {
				content: "${KEY.EDIT_OBSTRUCTION}";
				position: absolute;
				right: 3px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
			}
		}
	}	
	&#recalculate-layout{
		background: var(--defaultBgColor);
		border-right: 1px solid var(--borderLightColor);
		min-width: 40px;
		position: relative;
		@media (hover: hover) and (pointer: fine) {
			&:before {
					content: "${KEY.RECALCULATE_LAYOUT}";
					position: absolute;
					right: 2px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}
			// @media(max-width:860px){
			// height: 38px;
			// svg{
			// 	width: 20px;
			// 	height: 20px;
			// }
		// }
	}	
	&#delete-facet-mode{
		border-right: 1px solid var(--borderLightColor);
		width: 40px;
		position: relative;
		@media (hover: hover) and (pointer: fine){
			&:before {
					content: "${KEY.DELETE_FACET}";
					position: absolute;
					right: 2px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}
		// @media(max-width:860px){
		//  height: 38px;
			// svg{
			// 	width: 21px;
			// 	height: 20px;
			// }
		// }
	}
	&#delete-facet-mode-roof{
		border-right: 1px solid var(--borderLightColor);
		min-width: 40px;
		width: auto;
		position: relative;
		padding-right: 16px;
		@media (hover: hover) and (pointer: fine){
			&:before {
					content: "${ROOF_KEY.DELETE_FACET}";
					position: absolute;
					right: 10px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}
		// @media(max-width:860px){
		//  height: 38px;
			// svg{
			// 	width: 21px;
			// 	height: 20px;
			// }
		// }
	}
	&#undo-remove-shading{
		border-right: 1px solid var(--borderLightColor);
		background: var(--defaultBgColor);
		min-width: 43px;
		position: relative;
		padding-right: 16px;
		width: auto;
		@media (hover: hover) and (pointer: fine){
			&:before {
				content: "${KEY.ADJUST_SHADING}";
				position: absolute;
				right: 10px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
		}
		}
	}
	&#remove-shading{
		border-right: 1px solid var(--borderLightColor);
		background: var(--defaultBgColor);
		min-width: 40px;
		position: relative;
		// padding-right: 15px;
		width: auto;
		@media (hover: hover) and (pointer: fine){
			&:before {
				content: "${KEY.ADJUST_SHADING}";
				position: absolute;
				right: 3px;
				top: 1px;
				font-size:9px;
				color: var(--textColor);
			}
		}

		// @media(max-width:860px){
		//   height: 38px;
			// svg{
			// 	width: 17px;
			// 	height: 21px;
			// }
		// }
	}
	// &.facetundo{
	// 	padding: 0px 10px 0 6px;
	// 	min-width: 36px;
	// 	transform: scale(-1,1);
	// 	// background: #fff;
	// 	color: transparent;
	// 	border:none;
	// 	border-right: 1px solid #E4E4E4;
	// 	min-height: 27px;

	// 	&#undo{
	// 		height: 27px;
	// 		min-height: 27px;
	// 		padding: 0px 10px 0 6px;
	// 		// background:#fff !important;
	// 		// padding: .25rem 1.5rem;
	// 		// border-radius:25px;
	// 	}
		
	// 	svg{
	// 		position:relative;
	// 		top: -0.5px;
	// 	}
  // }	
	&#change-orientation{
			background: var(--defaultBgColor);
			border-right: 1px solid var(--borderLightColor);
			width: 40px;
			position: relative;
			@media (hover: hover) and (pointer: fine){
				&:before {
					content: "${KEY.ORIENTATION}";
					position: absolute;
					right: 2px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
				}
			}
		@media(max-width:860px){
		  height: 38px;
			svg{
				width: 20px;
				height: 20px;
			}
		}
	}
	&.btn-drawfacet{
		border-right: 1px solid var(--borderLightColor);
		padding: 0px 10px;
		position: relative;
		z-index: 2;
		@media (hover: hover) and (pointer: fine){
			&:before {
					content: '${KEY.DRAW}';
					position: absolute;
					right: 2px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}
					
			&.active{
				&:before {
						// background: color(srgb 0.91 0.91 0.99);
				}
		 }

		@media(max-width:860px){
		  height: 38px;
			// svg{
			// 	width: 23px;
			// 	height: 17px;
			// }
		}
	}
	&.btn-editfacet{
		border-right: 1px solid var(--borderLightColor);
		padding: 0px 6px;
		position: relative;

	@media (hover: hover) and (pointer: fine){
		&:before {
						content: '${KEY.EDIT}';
						position: absolute;
						right: 2px;
						top: 1px;
						font-size:9px;
						color: var(--textColor);
		}
	}

	@media(max-width:860px){
		height: 38px;
		// svg{
		// 	width: 23px;
		// 	height: 17px;
		// 	}
		}
	}
	// &#undo{
	// 		background: #fff;
	// 		border:none;
	// 		border-right: 1px solid #e4e4e4;
	// 		border-left: 0px;
	// 		color: #003CFF;
	// 		padding: 0px 10px;
	// 		transform: scale(-1, 1);
	// 		@media(max-width:860px){
	// 	 	 height: 30px;
	// 		 padding-left:6px;
	// 			svg{
	// 				width: 20px;
	// 				height: 20px;
	// 			}
	// 	}
	// }	
	// &#redo {
	// 		background: #fff;
	// 		border: 0px;
	// 		border-left: 1px solid #e4e4e4;
	// 		border-right: 0px;
	// 		color: #003CFF;
	// 		padding: 0px 4px 0 9px;

	// 		&.delete-obstruction-redo{
	// 			padding-left:10px;
	// 		}
	// 		@media(max-width:860px){
	// 	 	 height: 30px;
	// 			svg{
	// 				width: 20px;
	// 				height: 20px;
	// 			}
  //     }	
	// 		&.move-redo{
	// 				padding: 0 0.625rem 0 0.65rem;
	// 				height: 40px;
	// 				min-width: 38px;
	// 				border-radius: 0px;
	// 				height:30px;
	// 				border-left: 1px solid #e4e4e4;
	// 		}
	// }

	&.btn-edgetool{
		border-right: 1px solid var(--borderLightColor);
		padding: 0px 6px;
		position: relative;

	@media (hover: hover) and (pointer: fine){
		&:before {
						content: '${ROOF_KEY.EDIT_EDGES}';
						position: absolute;
						right: 2px;
						top: 1px;
						font-size:9px;
						color: var(--textColor);
		}
	}

	@media(max-width:860px){
		height: 38px;
		// svg{
		// 	width: 23px;
		// 	height: 17px;
		// 	}
		}
	}

	&.btn-edgetool-solar{
		border-right: 1px solid var(--borderLightColor);
		padding: 0px 6px;
		position: relative;

		@media (hover: hover) and (pointer: fine){
			&:before {
					content: '${KEY.EDIT_EDGES}';
					position: absolute;
					right: 3px;
					top: 1px;
					font-size:9px;
					color: var(--textColor);
			}
		}

		@media(max-width:860px){
			height: 38px;
		}
	}

	// &#undo{
	// 		background: #fff;
	// 		border:none;
	// 		border-right: 1px solid #e4e4e4;
	// 		border-left: 0px;
	// 		color: #003CFF;
	// 		padding: 0px 10px;
	// 		transform: scale(-1, 1);
	// 		@media(max-width:860px){
	// 	 	 height: 30px;
	// 		 padding-left:6px;
	// 			svg{
	// 				width: 20px;
	// 				height: 20px;
	// 			}
	// 	}
	// }	
	// &#redo {
	// 		background: #fff;
	// 		border: 0px;
	// 		border-left: 1px solid #e4e4e4;
	// 		border-right: 0px;
	// 		color: #003CFF;
	// 		padding: 0px 4px 0 9px;

	// 		&.delete-obstruction-redo{
	// 			padding-left:10px;
	// 		}
	// 		@media(max-width:860px){
	// 	 	 height: 30px;
	// 			svg{
	// 				width: 20px;
	// 				height: 20px;
	// 			}
  //     }	
	// 		&.move-redo{
	// 				padding: 0 0.625rem 0 0.65rem;
	// 				height: 40px;
	// 				min-width: 38px;
	// 				border-radius: 0px;
	// 				height:30px;
	// 				border-left: 1px solid #e4e4e4;
	// 		}
	// }

	&.months-btn	{
			font-weight: 500;
			font-size: 0.825rem;
			border-radius: 20px;
			@media(max-width:860px){
					min-height: 32px;
			}
	}		
	&.recommend-btn{
				border-radius: 20px;
				color: var(--defaultIconColor);
				background: var(--defaultBgColor);
				border: 1px solid var(--borderColor);
				white-space: nowrap;
				gap: 0.313rem;
				padding: 0.5125rem .82rem;
				font-size: .813rem;

				&:hover{
					background: var(--hoverBgColor);
				}

			@media(max-width:1280px){
				min-width: 38px;
				padding: 0.5125rem .25rem;
				svg{
					position:relative;
					left:2px;
				}
					label{
					display:none;
					}
			}
	}
	&.irradiance-btn{
		padding: 0.5125rem .72rem;
		gap: 0.313rem;
		font-size: .813rem;
		border-radius: 20px;
			@media(max-width:1024px){
				padding: 0.5125rem .45rem;
			}
			@media(max-width:540px){
				padding: 0.5125rem .35rem;
			}
	}
	&.calculating-btn {
		border-radius: 20px;
		color: var(--subHeadingColor);
		background: color-mix(in srgb, var(--secondary) 35%, var(--defaultBgColor));
		border: 1px solid var(--controlBorderColor);
		gap: 0.35rem;
		padding: 0.5125rem .82rem;
		cursor: default;
		pointer-events: none;
		white-space: nowrap;
		position: relative;
		overflow: hidden;
		label{
			position: relative;
			z-index: 1;
		}
		.calculating-bar{
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			overflow: hidden;
			z-index: 0;
		}
		.calculating-bar::after{
			content: '';
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			width: 40%;
			background: var(--secondary);
			animation: calculating-slide 1.3s ease-in-out infinite;
		}
		@keyframes calculating-slide{
			0%{ transform: translateX(-100%); }
			100%{ transform: translateX(250%); }
		}
		@media(max-width:1024px){
			padding: 0.5125rem .45rem;
		}
	}
	&.delete-facet-point{
	background: transparent;
	border: none;
	border-left: 1px solid var(--borderLightColor);
	height: auto;
	min-height: 30px;
	min-width: 38px;
	border-radius: 0px;
	margin-right:2px;
	}

	&.debug-btn, &.shortcuts-btn{
		background: var(--defaultBgColor);
		color: var(--surfaceColor);
		border-color: var(--controlBorderColor);
		border-radius:20px;
		padding: 0.5rem .5rem;
		min-width:38px;
		height: 38px;
		&.active{
			background: color-mix(in srgb, var(--primary) 18%, var(--defaultBgColor));
			border-color: var(--primary);
		}
		&:not(.active):hover{
			background: var(--hoverBgColor);
			opacity: 0.9;
		}
	}
	&#edge-tool{
		// border-left:1px solid #e4e4e4;
		// padding-right:12px;
		// padding-left:8px;
	}
  &:hover {
    opacity: .9;
  }

	&:disabled {
		cursor: not-allowed !important;
		opacity: .7;
	}
	&.close-icon{
		&:hover {
			background: var(--defaultBgColor);
		}
	}	
	&.save-btn{
			font-size: 1.125rem;
			line-height: 1.4;
			padding: 0.5rem 1.85rem;
			width: 100%;
			.showloader{
				&:disabled {
					cursor: not-allowed !important;
					opacity: 0.8 !important;
					pointer-events: none;
				}
      }
	
				&:disabled {
				cursor: not-allowed !important;
				opacity: 0.6 !important;
				background: #ccc;
				color: #878787;
				border-color: var(--borderColor);
				background: var(--toggleTrackColor);
		
		}
	}	
	&.resetLayoutButton{
		background-color: var(--dangerBgColor);
    color: var(--dangerTextColor);
    border: 1px solid #EF4444;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
		&:hover {
			background-color: #EF4444;
			color: var(--btnLabel);
		}
	}	
&.sidepanel-delete {
  outline: none;
  background: var(--defaultBgColor);
  color: var(--labelValueColor);
  border-color: var(--borderColor);
  font-weight: 500;
  min-width: unset;
  &:hover {
    opacity: 0.9;
    border-color: #ff9595 !important;
    background: var(--dangerHoverBgColor);
  }
}
	@media (max-width:1325px){
	// font-size: 0.856rem;
	gap:0.35rem;
	}

	&.sidepanel-done{
		min-height: 34px;
	}
	&.auto-detection-btn {
		border-radius: 20px;
		font-size: .813rem;
		color: var(--textTitleColor);
		line-height: 1.4;
		min-height: auto;
		padding:4px 12px;
		white-space: nowrap;
		margin-right: 6px;
		border-color: var(--borderLightColor);
    background: var(--btnBadge);
    color: var(--textTitleColor);

		&.auto-detection-btn-main{
			&:hover{
				border-color: rgb(37, 99, 235);
    		background: var(--controlActiveBgColor);
    		color: var(--primary);
			}
		}

		&:not(.remove),&:not(.re-run) {
			margin-right:6px;
		}

		&:not(.active):not(.no-action):hover,
		&:not(.active):not(.no-action):focus-visible {
			// background: var(--primary);
			opacity: 0.9;
		}

		&.no-action {
			pointer-events: none;
			cursor: default;
			border-color: rgb(74 82 90 / 13%);
    	background: var(--defaultBgLightColor);
    	color: var(--textTitleColor);
			opacity: .8 !important;
		}
		&.remove, &.re-run{
			padding: 5px 12px;
    	background: var(--defaultBgColor) !important;
    	color: var(--primary);
			border-color: var(--primary);
		}	
		&#merge-facets{
			&:hover{
				border-color: rgb(37, 99, 235);
    		background: var(--controlActiveBgColor);
    		color: var(--primary);
			}
		}
`;

// const ShowloaderWrap = styled.div`
// 	position: absolute;
// 	width: 100%;
// 	height:100%;
// 	background: rgba(57, 57, 57, 0.45);
// 	cursor: not-allowed;

// 	.showLoader{
// 		display: flex;
//     height: 100%;
//     width: 100%;
//     position: relative;

// 	&:before {
// 		content: '';
// 		display:block;
// 		position:absolute;
// 		height:100%;
// 		width:100%;
// 		top:0;
// 		left:0;
// 		background-color:inherit;
// 		z-index:1;
// 		opacity: .45
// 		}

// 	&:after {
// 		content: '';
// 		border: 4px solid red;
// 		border-color:  rgb(32 37 39 / 42%) hsl(40, 60%, 98%) #fdfbf7 !important;
// 		border-radius: 50%;
// 		border-top: 4px solid white;
// 		animation: spin 2s linear infinite;
// 		position: absolute;
// 		transform: translate(-50%, -50%);
// 		height: 50%;
// 		z-index: 10;
//     aspect-ratio: 1/1;
// 		top: 6px;
// 		left:0;
// 		right:0;
// 		margin: 0 auto;

// 		@-webkit-keyframes spin {
// 			0% {
// 				-webkit-transform: rotate(0deg);
// 			}
// 			100% {
// 				-webkit-transform: rotate(360deg);
// 			}
// 		}

// 		@keyframes spin {
// 			0% {
// 				transform: rotate(0deg);
// 			}
// 			100% {
// 				transform: rotate(360deg);
// 			}
// 	}
// }
// `;

const ShowloaderWrap = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.5);
  // backdrop-filter: blur(.2px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  z-index: 20;
  pointer-events: none;

  .showLoader {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.5);
    border-top-color: #fff;
    animation: spin 0.75s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export { ButtonStyle, ShowloaderWrap };